import React from "react";
import NegocioPhoto from "../../../images/landing/newphotos/negocio-padaria.jpg";
import "./style.css";
import "../../landing.css";
import localeText from "../../../../locale";

const items = [
  { icon: "pi pi-shop", title: "lp2NegocioItem1Title", desc: "lp2NegocioItem1Desc" },
  { icon: "pi pi-chart-line", title: "lp2NegocioItem2Title", desc: "lp2NegocioItem2Desc" },
  { icon: "pi pi-bolt", title: "lp2NegocioItem3Title", desc: "lp2NegocioItem3Desc" },
  { icon: "pi pi-wallet", title: "lp2NegocioItem4Title", desc: "lp2NegocioItem4Desc" },
];

export default function LandingAboutSectionOne() {
  return (
    <section className="negocio-gradient full-width py-8" id="negocio">
      <div className="eyebrow-text mb-2">{localeText("lp2NegocioEyebrow")}</div>
      <div className="grid align-items-start pb-4">
        <div className="col-12 lg:col-6">
          <div
            className="font-bold text-4xl md:text-5xl line-height-2 title"
            style={{ color: "var(--extra-green)" }}
          >
            {localeText("lp2NegocioTitle")}
          </div>
          <div className="text-lg mt-3" style={{ color: "var(--extra-body)", maxWidth: "46ch" }}>
            {localeText("lp2NegocioDescription")}
          </div>
        </div>
        <div className="col-12 lg:col-6">
          <div
            className="negocio-photo"
            style={{ backgroundImage: `url(${NegocioPhoto})` }}
            role="img"
            aria-label="Foto de uma padeira usando uma máquina de pagamento por aproximação para atender um cliente"
          />
        </div>
      </div>

      <div className="negocio-card">
        <div className="grid grid-nogutter">
          {items.map((item) => (
            <div key={item.title} className="col-12 md:col-6 negocio-cell">
              <div className="negocio-item">
                <i
                  className={item.icon}
                  style={{ color: "var(--extra-green)", fontSize: "1.6rem" }}
                ></i>
                <div className="font-bold text-lg mt-2" style={{ color: "var(--extra-ink)" }}>
                  {localeText(item.title)}
                </div>
                <div className="text-sm mt-1" style={{ color: "var(--extra-body)" }}>
                  {localeText(item.desc)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
